import "./pagination.css";
import React from "react";
import { Component } from "react";

class Pagination extends Component {
  constructor(props) {
    super(props);
    var platform = this.getScreenSize();

    this.addEvent(this.screenSizeChange);

    this.state = { pager: {}, platform: platform };
  }

  getScreenSize = (e) => {
    var platform;
    if (window.innerWidth <= 700) {
      platform = "Mobile";
    } else if (window.innerWidth > 700 && window.innerWidth <= 930) {
      platform = "Tablet";
    } else {
      platform = "Desktop";
    }
    return platform;
  };

  screenSizeChange = (e) => {
    if (
      window.matchMedia("(max-width: 700px)").matches ||
      window.innerWidth < 701
    ) {
      // get new pager object for specified page
      var pager = this.getPager(
        this.state.pager.totalItems,
        this.state.pager.currentPage
      );

      // update state
      this.setState({
        pager: pager,
        platform: "Mobile",
      });
    } else if (
      window.matchMedia("(max-width: 900px) and (min-width: 701px)").matches ||
      (window.innerWidth > 700 && window.innerWidth < 900)
    ) {
      // get new pager object for specified page
      var pager = this.getPager(
        this.state.pager.totalItems,
        this.state.pager.currentPage
      );

      // update state
      this.setState({
        pager: pager,
        platform: "Tablet",
      });
    } else {
      // get new pager object for specified page
      var pager = this.getPager(
        this.state.pager.totalItems,
        this.state.pager.currentPage
      );

      // update state
      this.setState({
        pager: pager,
        platform: "Desktop",
      });
    }
  };

  addEvent = (callback) => {
    if (window == null || typeof window == "undefined") return;
    if (window.addEventListener) {
      window.addEventListener("resize", callback, false);
    } else if (window.attachEvent) {
      window.attachEvent("onresize", callback);
    } else {
      window["onresize"] = callback;
    }
  };

  componentWillMount() {
    // set page if items array isn't empty
    if (this.props.items && this.props.items > 0) {
      this.setPage(this.props.initialPage);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (this.props.items !== prevProps.items && this.props.items > 0) ||
      (prevState.pager.currentPage !== this.state.pager.currentPage &&
        prevState.pager.currentPage > 0)
    ) {
      var items_length = this.props.items;
      var pager = this.state.pager;
      pager = this.getPager(items_length, this.props.initialPage);
      this.setState({ pager: pager });
    }
  }

  setPage(page, prev_items_length = 0) {
    if (page !== this.state.pager.currentPage && prev_items_length > 0) {
      this.props.onChangePage(page);
    }

    var items_length = this.props.items;

    var pager = this.state.pager;

    // if (page < 1 || page > pager.totalPages) {
    //     return;
    // }

    // get new pager object for specified page
    pager = this.getPager(items_length, page);

    // update state
    this.setState({ pager: pager });
  }

  getPager(totalItems, currentPage, pageSize) {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pageSize = pageSize || this.props.pageSize || 10;

    // calculate total pages
    var totalPages = Math.ceil(totalItems / pageSize);

    var paging_values = [];

    switch (this.state.platform) {
      case "Desktop":
        paging_values = this.hashDesktop(totalPages, currentPage);
        break;

      case "Tablet":
        paging_values = this.hashTablet(totalPages, currentPage);
        break;

      case "Mobile":
        paging_values = this.hashMobile(totalPages, currentPage);
        break;

      default:
        paging_values = this.hashDesktop(totalPages, currentPage);
        break;
    }
    var startPage = paging_values[0];
    var endPage = paging_values[1];

    // var startPage, endPage;
    // if (totalPages <= 10) {
    //     // less than 10 total pages so show all
    //     startPage = 1;
    //     endPage = totalPages;
    // } else {
    //     // more than 10 total pages so calculate start and end pages
    //     if (currentPage <= 6) {
    //         startPage = 1;
    //         endPage = 10;
    //     } else if (currentPage + 4 >= totalPages) {
    //         startPage = totalPages - 9;
    //         endPage = totalPages;
    //     } else {
    //         startPage = currentPage - 5;
    //         endPage = currentPage + 4;
    //     }
    // }

    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    var pages = [...Array(endPage + 1 - startPage).keys()].map(
      (i) => startPage + i
    );

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  }

  hashDesktop(totalPages, currentPage) {
    var startPage, endPage;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }
    return [startPage, endPage];
  }

  hashTablet(totalPages, currentPage) {
    var startPage, endPage;
    if (totalPages <= 6) {
      // less than 6 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 6 total pages so calculate start and end pages
      if (currentPage <= 4) {
        startPage = 1;
        endPage = 6;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 6;
        endPage = totalPages;
      } else {
        startPage = currentPage - 3;
        endPage = currentPage + 2;
      }
    }
    return [startPage, endPage];
  }

  hashMobile(totalPages, currentPage) {
    var startPage, endPage;
    if (totalPages <= 3) {
      // less than 3 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 3;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 2;
        endPage = totalPages;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 1;
      }
    }
    return [startPage, endPage];
  }

  render() {
    var pager = this.state.pager;
    this.addEvent(this.screenSizeChange);
    var items_length = this.props.items;
    if (!pager.pages || pager.pages.length <= 1 || items_length == 0) {
      // don't display pager if there is only 1 page

      return null;
    }

    return (
      <ul className='sgl-pagination pagination'>
        <li className={pager.currentPage === 1 ? "disabled" : "enabled"}>
          <a onClick={() => this.setPage(1, 1)}>&laquo;</a>
        </li>
        <li className={pager.currentPage === 1 ? "disabled" : "enabled"}>
          <a onClick={() => this.setPage(pager.currentPage - 1, 1)}>&larr;</a>
        </li>
        {pager.pages.map((page, index) => (
          <li
            key={index}
            className={pager.currentPage === page ? "active" : "non-active"}>
            <a onClick={() => this.setPage(page, 1)}>{page}</a>
          </li>
        ))}
        <li
          className={
            pager.currentPage === pager.totalPages ? "disabled" : "enabled"
          }>
          <a onClick={() => this.setPage(pager.currentPage + 1, 1)}>&rarr;</a>
        </li>
        <li
          className={
            pager.currentPage === pager.totalPages ? "disabled" : "enabled"
          }>
          <a onClick={() => this.setPage(pager.totalPages, 1)}>&raquo;</a>
        </li>
      </ul>
    );
  }
}

export default Pagination;
